export default __webpack_public_path__ + "static/media/ts.5fc03e65.png";